import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldAlert } from 'lucide-react';

export default function AccessDenied() {
  const params = new URLSearchParams(window.location.search);
  const email = params.get('email');
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="items-center text-center">
          <div className="rounded-2xl bg-destructive/10 p-4 mb-2">
            <ShieldAlert className="h-8 w-8 text-destructive" />
          </div>
          <CardTitle className="text-2xl">הגישה נדחתה</CardTitle>
          <CardDescription>
            {email ? (
              <>
                החשבון <strong>{email}</strong> אינו משויך לארגון פעיל במערכת.
              </>
            ) : (
              'החשבון אינו משויך לארגון פעיל במערכת.'
            )}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-2 text-center text-sm text-muted-foreground">
          <p>פנה למנהל המערכת לקבלת הרשאה.</p>
          <Button asChild variant="outline" className="mt-4">
            <a href="/auth/logout">התנתק ונסה חשבון אחר</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
